<template>
  <div>
    <ckeditor
      :editor="editor"
      v-model="editorData"
      @input="updateValue"
      :config="editorConfig"
    ></ckeditor>
  </div>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        toolbar: {
          items: [
            "heading",
            "|",
            "bold",
            "italic",
            "bulletedList",
            "numberedList",
            "imageUpload",
            "blockQuote",
            "undo",
            "redo",
          ],
        },
        removePlugins: ["MediaEmbed"],
        mediaEmbed: {},
        // The configuration of the editor.
      },
    };
  },
  watch: {
    value: {
      handler: function (newVal) {
        this.editorData = newVal; // Update editor content when prop value changes
      },
      deep: true,
    },
  },
  mounted() {
    setTimeout(() => {
      this.editorData = this.value;
    }, 100);
  },
  methods: {
    updateValue(data) {
      this.$emit("onChange", data);
    },
  },
};
</script>

<style>
.ck-editor__editable_inline {
  min-height: 200px;
}
</style>
